import { useContext, useEffect, useState } from "react";
import { buscarComboPorCodigo } from "../../../services/auth.service";
import { Autocomplete, Checkbox, TextField } from "@mui/material";
import { ExportRelatorioContext } from "../ExportRelatorioContext";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const Empresas = ({grupo = null}) => {
  const [grupos, setGrupos] = useState([]);
  const [grupoSelecionado, setGrupoSelecionado] = useState(grupo);
  const [listaEmpresas, setListaEmpresas] = useState([]);
  const { empresas, setEmpresas} = useContext(ExportRelatorioContext);  

  const handleRenderListAutoComplete = async (codCombo) => {
    try {
      const response = await buscarComboPorCodigo(codCombo);
      const combosFormat = response.detalhes.itensCombo
        .filter((item) => item)
        .map((item) => {
          const split = item.split("/|/");
          return {
            id: split[0],
            detalhes: split[1],
          };
        });

      const uniqueCombos = combosFormat.filter(
        (combo, index, self) =>
          index === self.findIndex((t) => t.detalhes === combo.detalhes)
      );

      return uniqueCombos;
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const buscarGrupos = async () => {
      try {
        const listaGrupos = await handleRenderListAutoComplete(
          "GRUPOECONOMICO"
        );
        setGrupos(listaGrupos);
      } catch (error) {
        console.log(error);
      }
    };
    grupos.length === 0 && buscarGrupos();
  }, []);

  useEffect(() => {
    const buscarEmpresas = async () => {
      try {
        const empresas = await handleRenderListAutoComplete(
          `EMPRESA_POR_GRUPO_${grupoSelecionado?.id}`
        );
        setListaEmpresas(empresas);
      } catch (error) {
        console.log(error);
      }
    };
    grupoSelecionado ? buscarEmpresas() : setListaEmpresas([]);
  }, [grupoSelecionado]);

  const handleChangeAutoComplete = (name, value) => {
    switch (name) {
      case "grupo":
        setGrupoSelecionado(value);
        setEmpresas([]);
        break;
      case "empresas":
        const isSelecionarTodos = value?.some(
          (empresa) => empresa.id === "selecionarTodos"
        );

        if (isSelecionarTodos) {
          const isAllSelected = empresas.length === listaEmpresas.length;

          if (isAllSelected) {
            setEmpresas([]);
          } else {
            setEmpresas(listaEmpresas);
          }
        } else {
          setEmpresas(value ?? []);
        }
        break;

      default:
        break;
    }
  };

  const allEmpresas = [
    { id: "selecionarTodos", detalhes: "Selecionar Todos" },
    ...listaEmpresas,
  ];

  return (
    <div>
      <Autocomplete
        sx={{ marginTop: "1rem" }}
        options={grupos || []}
        value={grupoSelecionado}
        onChange={(_, value) => handleChangeAutoComplete("grupo", value)}
        getOptionLabel={(option) => option.detalhes}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        fullWidth
        renderInput={(params) => (
          <TextField {...params} label="Grupo Econômico" />
        )}
      />
      {listaEmpresas.length > 0 && (
        <Autocomplete
          sx={{ marginTop: "1rem" }}
          multiple
          options={allEmpresas || []}
          value={empresas}
          onChange={(_, value) => handleChangeAutoComplete("empresas", value)}
          disableCloseOnSelect
          getOptionLabel={(option) => option.detalhes}
          fullWidth
          renderOption={(props, option, { selected }) => {
            const { key, ...optionProps } = props;
            return (
              <li key={key} {...optionProps}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.detalhes}
              </li>
            );
          }}
          renderInput={(params) => <TextField {...params} label="Empresas" />}
        />
      )}
    </div>
  );
};

export default Empresas;
